import { Box, Paper, Stack, Typography } from '@mui/material';
import { ResultRow } from '../../../pages/Ems/Components/ResultRow';
import VideoPlayer from '../../VideoPlayer';

export function SpeechAssessment({ speechDetails }) {
  const formattedDysarthriaValue = () => {
    if (!speechDetails?.dysarthriaResponse) {
      return 'Cannot determine';
    }
    return speechDetails?.dysarthriaDetected ? 'YES' : 'NO';
  };

  const formattedAphasiaValue = () => {
    if (!speechDetails?.aphasiaResponse) {
      return 'Cannot determine';
    }
    return speechDetails?.aphasiaDetected ? 'YES' : 'NO';
  };

  return (
    <Paper sx={{ padding: 2 }}>
      <Stack spacing={1}>
        <ResultRow title="Dysarthria (on device)" value={formattedDysarthriaValue()} />
        <Stack>
          <Typography variant="caption" color="textPrimary">
            Patient response
          </Typography>
          <Typography variant="body" color="textPrimary">
            {speechDetails.dysarthriaResponse}
          </Typography>
        </Stack>
        <ResultRow title="Aphasia (on device)" value={formattedAphasiaValue()} />
        <Stack>
          <Typography variant="caption" color="textPrimary">
            Patient response
          </Typography>
          <Typography variant="body" color="textPrimary">
            {speechDetails.aphasiaResponse}
          </Typography>
        </Stack>
        {speechDetails.aphasiaVideoUrl && (
          <Stack>
            <Typography variant="caption" color="textPrimary">
              Aphasia video
            </Typography>
            <Box sx={{ minWidth: '400px' }}>
                <VideoPlayer
                  url={`/strokeTests/${speechDetails.testId}/aphasiaVideo`}
                  height="450px"
                  width="795px"
                />
            </Box>
          </Stack>
        )}
      </Stack>
    </Paper>
  );
}
